<div class="modal-general">
  <div>
    @if (maxStep > 1) {
    <app-stepper [totalSteps]="maxStep" [currentStep]="stepSoftFilter"></app-stepper>
    }
    @if (stepSoftFilter == 1) {
    <div class="info">
      <h2>Queremos conocerte mejor, completa la siguiente información.</h2>
      <p>Ten en cuenta que esta quedará registrada en la aplicación con el aliado.</p>
    </div>
    }
    <form #datos="ngForm" (ngSubmit)="passSoftFilter()">
      <!-- name filter typeOfHousing-->
      @if (softFilterObject.typeOfHousing?.renderFilter == true) {
      <div>
        <label for="typeOfHousing">Tipo vivienda</label>
        <app-custom-select [listItems]="arrayTypeOfHousing" [placeholder]="'Elige un tipo de vivienda'"
          (selectItemEvent)="setValueTypeOfHousing($event)"></app-custom-select>
      </div>
      }
      <!-- name filter occupation-->
      @if (softFilterObject.occupation?.renderFilter == true) {
      <div>
        <label for="state">Estado/situación laboral</label>
        <app-custom-select [listItems]="arrayOccupation" [placeholder]="'Elige un estado'"
          (selectItemEvent)="setValueOccupation($event)"></app-custom-select>
      </div>
      }
      <!-- name filter monthlyIncome-->
      @if (softFilterObject.monthlyIncome?.renderFilter == true) {
      <div>
        <label for="state">Ingresos Mensuales</label>
        <input class="input" type="text" min="0" [(ngModel)]="monthlyIncomeFormat"
          placeholder="Ingrese ingresos mensuales" placeholder="$0 COP" name="monthlyIncome"
          (input)="onInputChange($event)">
      </div>
      }
      <!-- name filter monthlyExpenses-->
      @if (softFilterObject.monthlyExpenses?.renderFilter == true) {
      <div>
        <label for="state">Gastos Mensuales</label>
        <input class="input text-align-center" type="text" min="0" [(ngModel)]="monthlyExpensesFormat"
          placeholder="Ingrese gastos mensuales" placeholder="$0 COP" name="monthlyExpenses"
          (input)="onInputChange($event)">
      </div>
      }
      <!-- name filter civilStatus-->
      @if (softFilterObject.civilStatus?.renderFilter == true) {
      <div>
        <label for="state">Estado Civil</label>
        <app-custom-select [listItems]="arrayCivilStatus" [placeholder]="'Elige un estado civil'"
          (selectItemEvent)="setValueCivilStatus($event)"></app-custom-select>
      </div>
      }
      <!-- name filter employmentTenure-->
      @if (softFilterObject.employmentTenure?.renderFilter === true) {
      <div>
        <label>Antigüedad (En meses)</label>
        <input type="number" min="0" max="100" class="input" [(ngModel)]="softFilterObject.employmentTenure.value"
          placeholder="Ingrese tiempo en meses" name="employmentTenure">
      </div>
      }
      <!-- name filter daneId-->
      @if (softFilterObject.daneId?.renderFilter == true) {
      <div>
        <label for="daneId">Ciudad residencia</label>
        <app-custom-select [listItems]="cities" [placeholder]="'Elige una ciudad'"
          (selectItemEvent)="setValueDaneId($event)"></app-custom-select>
      </div>
      }
      <!-- name filter birthDate-->
      @if (softFilterObject.birthDate?.renderFilter === true) {
      <div>
        <label for="state">Fecha nacimiento</label>
        <div class="input-container input-with-icon">
          <input type="text" class="input" name="birthDate" placeholder="DD/MM/AAAA"
            [(ngModel)]="softFilterObject.birthDate.value" [matDatepicker]="picker" [max]="maxDate" required="required"
            (input)="formatBirthDateInput($event, 'birthDate')" maxlength="10">
          <mat-datepicker-toggle class="date-icon" [for]="picker">
            <mat-icon matDatepickerToggleIcon>
              <img src="assets/images/modals/calendario1.svg" width="24" height="24" alt="calendario">
            </mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>
      }
      <!-- name filter expeditionDate-->
      @if (softFilterObject.expeditionDate?.renderFilter === true) {
      <div>
        <label for="state">Fecha expedición</label>
        <div class="input-container input-with-icon">
          <input type="text" class="input" name="expeditionDate" placeholder="DD/MM/AAAA"
            [(ngModel)]="softFilterObject.expeditionDate.value" [matDatepicker]="picker" [max]="maxDate"
            required="required" (input)="formatBirthDateInput($event, 'expeditionDate')" maxlength="10">
          <mat-datepicker-toggle class="date-icon" [for]="picker">
            <mat-icon matDatepickerToggleIcon>
              <img src="assets/images/modals/calendario1.svg" width="24" height="24" alt="calendario">
            </mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </div>
      </div>
      }
      <!-- name filter gender-->
      @if (softFilterObject.gender?.renderFilter == true) {
      <div>
        <label for="gender">Genero</label>
        <app-custom-select [listItems]="arrayGender" [placeholder]="'Elige un genero'"
          (selectItemEvent)="setValueGender($event)"></app-custom-select>
      </div>
      }
      <!-- name filter occupation-->
      @if (softFilterObject.dependentsNumber?.renderFilter == true) {
      <div>
        <label for="dependentsNumber">Personas a cargo</label>
        <app-custom-select [listItems]="arrayDependentsNumber" [placeholder]="'Elige numero de personas a cargo'"
          (selectItemEvent)="setValueDependentsNumber($event)"></app-custom-select>
      </div>
      }
      <div class="container margin-top-20px">
        <div class="row">
          <button type="button" class="cta-button secondary btn-right" (click)="closeModalConfirm()">
            Cancelar
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </button>
          <button type="submit" [attr.disabled]="validateForm() != false ? null : 'disabled'"
            [ngClass]="{'disabled': validateForm() == false}" type="submit" class="cta-button btn-left">
            Continuar
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </button>
        </div>
        <div class="row margin-top-12px">
          <button type="button" class="btn-mrkt secondary" (click)="updatePhone()">
            Actualizar mi número de celular
          </button>
        </div>
      </div>
    </form>
  </div>
</div>